var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLowTolerance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#162660"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3759_10875)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1665 18.5003H16.8332V20.167H15.1665V18.5003ZM15.1665 11.8337H16.8332V16.8337H15.1665V11.8337ZM15.9915 7.66699C11.3915 7.66699 7.6665 11.4003 7.6665 16.0003C7.6665 20.6003 11.3915 24.3337 15.9915 24.3337C20.5998 24.3337 24.3332 20.6003 24.3332 16.0003C24.3332 11.4003 20.5998 7.66699 15.9915 7.66699ZM15.9998 22.667C12.3165 22.667 9.33317 19.6837 9.33317 16.0003C9.33317 12.317 12.3165 9.33366 15.9998 9.33366C19.6832 9.33366 22.6665 12.317 22.6665 16.0003C22.6665 19.6837 19.6832 22.667 15.9998 22.667Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3759_10875"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowTolerance);
export default __webpack_public_path__ + "static/media/lowTolerance.ff356952037b5c0b00bd103302169ca9.svg";
export { ForwardRef as ReactComponent };